module.exports = __webpack_public_path__ + "static/assets/a5787bb7364d8131ed49a8f53037d7f4.svg";